import * as UI from "@iyk/ui"

import { each } from "@iyk/flow"
import { Video } from "../ui/video.tsx"

import "./tagline.css"

//#region Tagline

export const Tagline = ({ content }: { content: TaglineContent[] }) => {
  return (
    <div className={classNameForRoot()}>
      {each(content, (item, index) => {
        if (item.type === "word") {
          return (
            <Word className="animated-tagline-word" index={index} key={index}>
              {item.value}
            </Word>
          )
        }
        return (
          <SquareVideo
            className="animated-tagline-video"
            srcset={item.srcset ?? []}
            index={index}
            key={index}
          />
        )
      })}
    </div>
  )
}

const classNameForRoot = UI.cva([
  "inline-flex flex-wrap items-center justify-center",
  "px-4 mx-auto",
  "max-w-80 md:max-w-none md:w-[clamp(0px,50vw,740px)]",
  "leading-[1.02] tracking-[-1px]",
  "gap-[clamp(0px,1vw,16px)]",
  "text-4xl md:text-[clamp(24px,4vw,64px)]",
])

export type TaglineContent =
  | { type: "word"; value: string }
  | { type: "video"; srcset: { type: string; src: string }[] }

//#endregion

//#region Word

const Word = ({ index, style, ...props }: MotionSpanProps) => {
  return (
    <span
      style={{
        ...style,
        "--index": index.toString(),
      }}
      {...props}
    />
  )
}

//#endregion

//#region SquareVideo

const SquareVideo = ({ srcset, index, style, className, ...props }: SquareVideoProps) => (
  <span
    className={classNameForSquareVideoContainer({ className })}
    style={{
      ...style,
      "--index": index.toString(),
    }}
    {...props}
  >
    <Video className={classNameForSquareVideo()} aria-hidden="true">
      {each(srcset, ({ type, src }) => (
        <source key={src} src={src} type={type} />
      ))}
    </Video>
  </span>
)

const classNameForSquareVideoContainer = UI.cva([
  "relative inline-block",
  "w-10 md:w-[clamp(24px,5vw,80px)]",
  "h-px shrink-0",
])

const classNameForSquareVideo = UI.cva([
  "absolute top-0 left-0",
  "size-10 md:size-[clamp(24px,5vw,80px)]",
  "border-[clamp(2.7px,0.4vw,6.4px)] border-transparent",
  "shadow-[clamp(2px,0.4vw,6px)_clamp(2px,0.4vw,6px)_0_0_rgba(0,0,0,0.05)]",
  "transform -translate-y-[50%]",
  "object-cover object-center",
])

//#endregion

//#region Types

type MotionSpanProps = JSX.IntrinsicElements["span"] & {
  index: number
}

type SquareVideoProps = {
  srcset: {
    type: string
    src: string
  }[]
} & MotionSpanProps

//#endregion
